import BlogForm from "../component/BlogForm";

const BlogCreate = () => {
  return <BlogForm isEditMode={false} />;
};

export default BlogCreate;
